interface AudioLevelMeterProps {
  /** Normalised input level, 0..1. */
  level: number;
  /** Whether real audio input has been detected (turns the bar green). */
  active: boolean;
}

/** Animated Google-Meet-style microphone input level bar. */
export function AudioLevelMeter({ level, active }: AudioLevelMeterProps) {
  const pct = Math.max(4, Math.round(Math.min(1, Math.max(0, level)) * 100));
  return (
    <div
      className="h-3 w-full bg-slate-100 rounded-full overflow-hidden"
      role="meter"
      aria-label="Microphone input level"
      aria-valuenow={Math.round(Math.min(1, Math.max(0, level)) * 100)}
      aria-valuemin={0}
      aria-valuemax={100}
    >
      <div
        className={`h-full rounded-full transition-[width] duration-75 ${
          active ? "bg-green-500" : "bg-brand-500"
        }`}
        style={{ width: `${pct}%` }}
      />
    </div>
  );
}
